export const testData = [
    { name: "Complete Blood Count (CBC) - 3 Part", currate: 225, orrate: 250 },
    { name: "Malarial (Parasite V & F)", currate: 315, orrate: 350 },
    { name: "Widal Test", currate: 180, orrate: 200 },
    { name: "FEVER PROFILE", currate: 495, orrate: 550 },
    { name: "Erythrocyte Sedimentation Rate (ESR)", currate: 90, orrate: 100 },
    { name: "Electrolyte Profile - Serum", currate: 315, orrate: 350 },
    { name: "Thyroid Stimulating Hormone (TSH)", currate: 270, orrate: 300 },
    { name: "Thyroid Profile I", currate: 450, orrate: 500 },
    { name: "Thyroid Profile - IV", currate: 720, orrate: 800 },
    { name: "Creatinine", currate: 135, orrate: 150 },
    { name: "Urea", currate: 135, orrate: 150 },
    { name: "Uric Acid", currate: 270, orrate: 300 },
    { name: "C-Reactive Protein (CRP)", currate: 360, orrate: 400 },
    { name: "Complete Urine Analysis (CUE)", currate: 90, orrate: 100 },
    { name: "Glucose -Blood- Fasting(FBS)", currate: 63, orrate: 70 },
    { name: "Glucose -Blood- Post Prandial(PP)(PLSB)", currate: 63, orrate: 70 },
    { name: "Glucose -Blood- Random(RBS)", currate: 63, orrate: 70 },
    { name: "HBA1C", currate: 540, orrate: 600 },
    { name: "LFT", currate: 450, orrate: 500 },
    { name: "Billirubin", currate: 225, orrate: 250 },
    { name: "Rhematoid Factor (RA Test)", currate: 495, orrate: 550 },
    { name: "ASO Titer", currate: 540, orrate: 600 },
    { name: "Lipid Profile", currate: 450, orrate: 500 },
    { name: "Cholestrol Total", currate: 270, orrate: 300 },
    { name: "HIV 1& 2 (Rapid)", currate: 315, orrate: 350 },
    { name: "HBS Ag", currate: 270, orrate: 300 },
    { name: "HCV (Rapid)", currate: 540, orrate: 600 },
    { name: "VDRL- Syphilis Antibodies", currate: 180, orrate: 200 },
    { name: "Hemoglobin", currate: 90, orrate: 100 },
    { name: "Coombs Test - Direct", currate: 405, orrate: 450 },
    { name: "Coombs Test - Indirect", currate: 450, orrate: 500 },
    { name: "Culture And Sensivity", currate: 405, orrate: 450 },
    { name: "Blood for Culture and Sensivity", currate: 1080, orrate: 1200 },
    { name: "Creatine Kinase MB (CK-MB)", currate: 450, orrate: 500 },
    { name: "CRP-High Sensitive (hsCRP)", currate: 540, orrate: 600 },
    { name: "Amylase", currate: 450, orrate: 500 },
    { name: "Estradiol (E2)", currate: 450, orrate: 500 },
    { name: "Ferritin", currate: 540, orrate: 600 },
    { name: "Folate Serum (Folic Acid)", currate: 765, orrate: 850 },
    { name: "Follicle Stimulating Hormone (FSH)", currate: 360, orrate: 400 },
    { name: "Globulin", currate: 117, orrate: 130 },
    { name: "Glucose 6 Phosphate Dehydrogenase (G6PD Quantitative)", currate: 630, orrate: 700 },
    { name: "Glucose Challenge Test (50 Gms of glucose)", currate: 270, orrate: 300 },
    { name: "Growth Hormone (GH)", currate: 585, orrate: 650 },
    { name: "Insulin", currate: 585, orrate: 650 },
    { name: "Intact Parathyroid Hormone (iPTH)", currate: 1080, orrate: 1200 },
    { name: "Iodine - Serum", currate: 1350, orrate: 1500 },
    { name: "Iron", currate: 270, orrate: 300 },
    { name: "Iron Binding Capacity - Total (TIBC)", currate: 270, orrate: 300 },
    { name: "Lactate Dehydrogenase (LDH)-Serum", currate: 270, orrate: 300 },
    { name: "Lipase", currate: 495, orrate: 550 },
    { name: "Luteinising Hormone (LH)", currate: 360, orrate: 400 },
    { name: "Magnesium", currate: 315, orrate: 350 },
    { name: "Phosphorus", currate: 180, orrate: 200 },
    { name: "Potassium", currate: 117, orrate: 130 },
    { name: "Pregnancy Test", currate: 135, orrate: 150 },
    { name: "Progesterone", currate: 450, orrate: 500 },
    { name: "Prolactin", currate: 360, orrate: 400 },
    { name: "Protein Total", currate: 117, orrate: 130 },
    { name: "Protein Total with Albumin", currate: 198, orrate: 220 },
    { name: "Sodium - Serum", currate: 117, orrate: 130 },
    { name: "Testosterone - Total", currate: 450, orrate: 500 },
    { name: "Thyroxine - Free (FT4)", currate: 270, orrate: 300 },
    { name: "Thyroxine - Total (TT4)", currate: 180, orrate: 200 },
    { name: "Troponin - I", currate: 1350, orrate: 1500 },
    { name: "Troponin - T", currate: 1350, orrate: 1500 },
    { name: "TSH Receptor Antibodies", currate: 2880, orrate: 3200 },
    { name: "Vitamin - B12", currate: 765, orrate: 850 },
    { name: "Vitamin B1 - Serum", currate: 6750, orrate: 7500 },
    { name: "Vitamin-A", currate: 3150, orrate: 3500 },
    { name: "Vitamin-D", currate: 810, orrate: 900 },
    { name: "Zinc-Serum", currate: 1620, orrate: 1800 },
    { name: "Anemia Profile", currate: 1800, orrate: 2000 },
    { name: "Ante Natel Profile Rapid", currate: 1080, orrate: 1200 },
  ];
  